import * as React from "react";
import PropTypes from "prop-types";
import useAutocomplete from "@mui/material/useAutocomplete";
import { styled } from "@mui/material/styles";
import { autocompleteClasses } from "@mui/material/Autocomplete";
import { CgClose } from "react-icons/cg";
import { useEffect, useMemo, useState } from "react";
import { REHouse, RELocation } from "../icons/IconSvg";

const Root = styled("div")(({ theme }) => ({
    color: "rgba(0,0,0,0.85)",
    fontSize: "14px",
    ...theme.applyStyles("dark", {
        color: "rgba(255,255,255,0.65)",
    }),
}));
const InputWrapper = styled("div")(({ theme }) => ({
    width: "300px",
    border: "1px solid #b8b8b8",
    backgroundColor: "#fff",
    borderRadius: "4px",
    // padding: "1px",
    padding: "4px 20px 4px 12px",
    display: "flex",
    flexWrap: "wrap",
    ...theme.applyStyles("dark", {
        borderColor: "#434343",
        backgroundColor: "#141414",
    }),
    "&:hover": {
        borderColor: "#f15a24",
        ...theme.applyStyles("dark", {
            borderColor: "#177ddc",
        }),
    },
    "&.focused": {
        borderColor: "#f15a24",
        boxShadow: "0 0 0 2px #f15a2412",
        ...theme.applyStyles("dark", {
            borderColor: "#177ddc",
        }),
    },
    "& input": {
        backgroundColor: "#fff",
        color: "rgba(0,0,0,.85)",
        height: "30px",
        boxSizing: "border-box",
        padding: "4px 6px",
        width: "0",
        minWidth: "30px",
        flexGrow: 1,
        border: 0,
        margin: 0,
        outline: 0,
        ...theme.applyStyles("dark", {
            color: "rgba(255,255,255,0.65)",
            backgroundColor: "#141414",
        }),
    },
}));

function Tag(props) {
    const { label, onDelete, plshdr, kName, selectOptions, setSelectOptions, filterCallBack, ...other } = props;
    const onReset = () => {
        if (selectOptions && plshdr) {
            const updatedOptions = { ...selectOptions };
            const existing = updatedOptions[plshdr] || [];
            updatedOptions[plshdr] = existing.filter((val) => val !== label);
            setSelectOptions(updatedOptions);
            filterCallBack(updatedOptions);
        }
    };
    return (
        <div {...other}>
            <span>{label}</span>
            {/* <p onClick={onDelete} >*</p> */}
            <CgClose
                onClick={() => {
                    onReset();
                    onDelete();
                }}
            />
        </div>
    );
}
Tag.propTypes = {
    label: PropTypes.string.isRequired,
    onDelete: PropTypes.func.isRequired,
    plshdr: PropTypes.string.isRequired,
    kName: PropTypes.string.isRequired,
    selectOptions: PropTypes.object.isRequired,
    setSelectOptions: PropTypes.func.isRequired,
    filterCallBack: PropTypes.func.isRequired,
};

const StyledTag = styled(Tag)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    height: "30px",
    margin: "2px",
    lineHeight: "22px",
    backgroundColor: "#fafafa",
    border: `1px solid #e8e8e8`,
    borderRadius: "2px",
    boxSizing: "content-box",
    padding: "0 4px 0 10px",
    outline: 0,
    overflow: "hidden",
    ...theme.applyStyles("dark", {
        backgroundColor: "rgba(255,255,255,0.08)",
        borderColor: "#303030",
    }),
    "&:focus": {
        borderColor: "#f15a24",
        backgroundColor: "#f15a2412",
        ...theme.applyStyles("dark", {
            backgroundColor: "#003b57",
            borderColor: "#177ddc",
        }),
    },
    "& span": {
        overflow: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
    "& svg": {
        fontSize: "22px",
        cursor: "pointer",
        padding: "4px",
    },
}));

const Listbox = styled("ul")(({ theme }) => ({
    width: "300px",
    margin: "2px 0 0",
    padding: 0,
    position: "absolute",
    listStyle: "none",
    backgroundColor: "#fff",
    overflow: "auto",
    maxHeight: "250px",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgb(0 0 0 / 0.15)",
    zIndex: 2,
    ...theme.applyStyles("dark", {
        backgroundColor: "#141414",
    }),
    "& li": {
        padding: "6px 12px",
        display: "flex",
        "& span": {
            flexGrow: 1,
        },
    },
    "& li[aria-selected='true']": {
        backgroundColor: "#f15a2412",
        fontWeight: 600,
        ...theme.applyStyles("dark", {
            backgroundColor: "#2b2b2b",
        }),
    },
    [`& li.${autocompleteClasses.focused}`]: {
        backgroundColor: "#f15a2412",
        cursor: "pointer",
        ...theme.applyStyles("dark", {
            backgroundColor: "#003b57",
        }),
    },
}));

export default function AutoMultiSearch({ data, filterData, filterCallBack, kName, plshdr, multiShow, limitTags = 1, isIcon, filterReset }) {
    let names = ["city", "locality"];
    const [selectOptions, setSelectOptions] = useState();
    const [selectName, setSelectName] = useState("");
    const uniqueData = useMemo(() => {
        if (data && data?.length > 0) {
            return Array.from(new Map(data?.map((item) => [item?.[kName], item])).values());
        }
    }, [data]);

    // useEffect(() => {
    //     if (filterData && uniqueData) {
    //         const keyNames = uniqueData.map((item) => item.Keyname);
    //         if (multiShow) {
    //             // if (plshdr === "locality") {
    //             //     const selectedObj = filterData?.locality?.map((name) => uniqueData?.find((item) => item?.name === name)).filter((item) => item !== undefined);
    //             //     setSelectOptions(selectedObj);
    //             // }
    //         } else {
    //             const matchingKeyName = keyNames.find((keyname) => names.includes(keyname));
    //             if (matchingKeyName) {
    //                 setSelectName(matchingKeyName);
    //             }
    //             if (filterData.city !== "") {
    //                 const selectedObj = uniqueData.find((item) => item?.[kName] === filterData.city);
    //                 setSelectOptions(selectedObj || null);
    //             }
    //             if (filterData.locality !== "") {
    //                 const selectedObj = uniqueData.find((item) => item?.[kName] === filterData.locality);
    //                 setSelectOptions(selectedObj || null);
    //             }
    //         }
    //     }
    //     //  else setSelectOptions();
    // }, [filterData, uniqueData, kName, selectOptions]);
    useEffect(() => {
    if (filterData && uniqueData) {
        const keyNames = uniqueData.map((item) => item.Keyname);

        if (!multiShow) {
            const matchingKeyName = keyNames.find((keyname) =>
                names.includes(keyname)
            );
            if (matchingKeyName) {
                setSelectName(matchingKeyName);
            }

            if (!filterData.city && !filterData.locality) {
                setSelectOptions(null); // ✅ sync reset
                return;
            }

            const value =
                filterData.city || filterData.locality;

            const selectedObj = uniqueData.find(
                (item) => item?.[kName] === value
            );

            setSelectOptions(selectedObj || null);
        }
    }
}, [filterData, uniqueData, kName]);

    const onChangeData = (e, newValue) => {
        let keyValue;
        if (names.includes(newValue?.Keyname)) {
            keyValue = newValue?.Keyname;
            setSelectName(newValue?.Keyname);
        }
        let option = { ...filterData };
        if (keyValue === "city") option["locality"] = "";
        else option["locality"] = option["city"] = "";
        if (multiShow) {
            setSelectOptions(newValue);
            const itemData = newValue.map((item) => item?.[kName]);
            const updated = { ...option, [keyValue]: itemData };
            filterCallBack(updated);
        } else {
            setSelectOptions(newValue ? newValue : []);
            const updated = { ...option, [keyValue]: newValue?.[kName] || "" };
            filterCallBack(updated);
        }
    };
    const { getRootProps, getInputProps, getTagProps, getListboxProps, getOptionProps, groupedOptions, focused, setAnchorEl, inputValue } = useAutocomplete({
        value: multiShow ? selectOptions || [] : selectOptions || "",
        multiple: multiShow,
        options: data,
        onChange: onChangeData,
        getOptionLabel: (option) => {
            return option?.[kName] || "";
        },
    });
    const handleDropdown = (value, name) => {
        const option = filterData;
        const optionName = option[name] || [];
        if (!optionName.includes(value)) {
            optionName.push(value);
            option[name] = optionName;
            filterCallBack(option);
        }
    };
    const handleSinglevalue = (value, name) => {
        const option = filterData;
        if (name === "locality") {
            let findData = data.find((item) => item.name === value);
            option[name] = findData?.type;
        } else if (name === "city") {
            let findData = data.find((item) => item.cityName === value);
            option[name] = findData?.cityName;
        }
        filterCallBack(option);
    };
    // const onfilterReset = (e) => {
    //     if (!e.target.value) {
    //         let tmp_option = filterData;
    //         tmp_option["locality"] = "";
    //         tmp_option["city"] = "";
    //         setSelectOptions(tmp_option);
    //         if (filterReset) filterReset(tmp_option);
    //     }
    // };
    const onfilterReset = (e) => {
    if (!e.target.value) {
        const tmp_option = {
            ...filterData,
            city: "",
            locality: "",
        };

        setSelectOptions(null); // ✅ CLEAR selected option
        filterCallBack(tmp_option);

        if (filterReset) filterReset(tmp_option);
    }
};

    return (
        <>
            <Root>
                <div {...getRootProps()}>
                    <InputWrapper ref={setAnchorEl} className={focused ? "focused" : ""} onChange={onfilterReset}>
                        {multiShow && selectOptions?.length > 0 && (
                            <>
                                {!focused ? (
                                    <>
                                        {selectOptions.slice(0, limitTags).map((option, index) => {
                                            const { key, ...tagProps } = getTagProps({ index });
                                            return <StyledTag key={key} {...tagProps} label={option?.[kName]} />;
                                        })}
                                        {selectOptions.length > limitTags && <p>+{selectOptions.length - 1}</p>}
                                    </>
                                ) : (
                                    <>
                                        {selectOptions?.map((option, index) => {
                                            const { key, ...tagProps } = getTagProps({ index });
                                            return <StyledTag key={key} {...tagProps} label={option?.[kName]} />;
                                        })}
                                    </>
                                )}
                            </>
                        )}
                        {isIcon && <RELocation />}
                        {/* <input  {...getInputProps()} placeholder={plshdr} /> */}
                        <input type="search" {...getInputProps()} placeholder={plshdr} />
                    </InputWrapper>
                </div>
                {inputValue && inputValue !== "" ? (
                    groupedOptions.length > 0 ? (
                        <Listbox {...getListboxProps()}>
                            {groupedOptions.map((option, index) => {
                                const { key, ...optionProps } = getOptionProps({ option, index });
                                return (
                                    <li
                                        key={option.id}
                                        {...optionProps}
                                        style={{
                                            fontWeight: option.highlight ? 700 : 400,
                                        }}
                                    >
                                        <div className="option_icon">{option.Keyname === "city" ? <RELocation /> : <REHouse />}</div>
                                        <div className="option_tag">
                                            <span
                                                onClick={() => {
                                                    multiShow ? handleDropdown(option?.[kName], option.Keyname) : handleSinglevalue(option?.[kName], option.Keyname);
                                                }}
                                            >
                                                {option?.[kName]}
                                            </span>
                                        </div>
                                    </li>
                                );
                            })}
                        </Listbox>
                    ) : null
                ) : null}
            </Root>
        </>
    );
}
